(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sacrenom-niche-product"] && !Shopify.designMode) return;
  try {
    
  if (!window.srNicheProductInstalled) {
    window.srNicheProductInstalled = true;
    document.addEventListener('input', function(event) {
      const input = event.target.closest('[data-np-input]');
      if (!input) return;
      const root = input.closest('[data-niche-preview]');
      if (!root) return;
      const type = input.dataset.npInput;
      const preview = root.querySelector('[data-np-preview="' + type + '"]');
      const counter = root.querySelector('[data-np-count="' + type + '"]');
      if (preview) preview.textContent = input.value.trim() || (type === 'primary' ? root.dataset.placeholder : '');
      if (counter) counter.textContent = input.value.length + ' / ' + input.maxLength;
    });
    document.addEventListener('change', function(event) {
      const select = event.target.closest('[data-np-variant], [data-np-style], [data-np-motif-select]');
      if (!select) return;
      const root = select.closest('[data-niche-preview]');
      if (!root) return;
      const option = select.selectedOptions[0];
      if (select.matches('[data-np-variant]')) {
        const price = root.querySelector('[data-np-price]');
        const stickyPrice = root.querySelector('[data-np-sticky-price]');
        if (option && price) price.textContent = option.dataset.price;
        if (option && stickyPrice) stickyPrice.textContent = option.dataset.price;
      }
      if (select.matches('[data-np-style]')) {
        const previewText = root.querySelector('[data-np-preview-text]');
        if (previewText) previewText.dataset.font = select.value;
      }
      if (select.matches('[data-np-motif-select]')) {
        const motif = root.querySelector('[data-np-preview-motif]');
        if (motif) motif.textContent = select.value;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
